import { Staff } from '../types';

let staffDatabase: Staff[] = [
  {
    id: "staff-1",
    empCode: "STF-0001",
    role: "doctor",
    department: "Cardiology",
    status: "active",
    name: "Dr. Sarah Johnson",
    gender: "female",
    dob: "1985-03-15",
    phone: "+1234567890",
    email: "sarah.johnson@medsystem.com",
    address: "123 Medical Ave, City",
    qualification: "MD, Cardiology",
    licenseNo: "MD-12345",
    specialization: "Interventional Cardiology",
    experienceYears: 12,
    salary: 150000,
    bloodGroup: "O+",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "staff-2",
    empCode: "STF-0002",
    role: "nurse",
    department: "Emergency",
    status: "active",
    name: "Maria Rodriguez",
    gender: "female",
    dob: "1990-07-22",
    phone: "+1234567891",
    email: "maria.rodriguez@medsystem.com",
    address: "456 Care St, City",
    qualification: "BSN",
    licenseNo: "RN-67890",
    experienceYears: 8,
    salary: 75000,
    bloodGroup: "A+",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "staff-3",
    empCode: "STF-0003",
    role: "pharmacist",
    department: "Pharmacy",
    status: "active",
    name: "James Chen",
    gender: "male",
    dob: "1988-11-10",
    phone: "+1234567892",
    email: "james.chen@medsystem.com",
    address: "789 Pharmacy Blvd, City",
    qualification: "PharmD",
    licenseNo: "PH-11111",
    experienceYears: 10,
    salary: 95000,
    bloodGroup: "B+",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  }
];

let nextId = 4;

export const staffService = {
  async getAll(filters?: {
    role?: string;
    department?: string;
    status?: string;
    search?: string;
  }): Promise<Staff[]> {
    await new Promise(resolve => setTimeout(resolve, 100)); // Simulate API delay
    
    let filtered = [...staffDatabase];
    
    if (filters?.role) {
      filtered = filtered.filter(staff => staff.role === filters.role);
    }
    
    if (filters?.department) {
      filtered = filtered.filter(staff => staff.department === filters.department);
    }
    
    if (filters?.status) {
      filtered = filtered.filter(staff => staff.status === filters.status);
    }
    
    if (filters?.search) {
      const searchLower = filters.search.toLowerCase();
      filtered = filtered.filter(staff => 
        staff.name.toLowerCase().includes(searchLower) ||
        staff.empCode.toLowerCase().includes(searchLower) ||
        staff.email?.toLowerCase().includes(searchLower)
      );
    }
    
    return filtered.sort((a, b) => a.empCode.localeCompare(b.empCode));
  },

  async getById(id: string): Promise<Staff | null> {
    await new Promise(resolve => setTimeout(resolve, 100));
    return staffDatabase.find(staff => staff.id === id) || null;
  },

  async create(staffData: Omit<Staff, 'id' | 'empCode' | 'createdAt' | 'updatedAt'>): Promise<Staff> {
    await new Promise(resolve => setTimeout(resolve, 200));
    
    const lastEmpCode = staffDatabase
      .map(s => parseInt(s.empCode.split('-')[1]))
      .sort((a, b) => b - a)[0] || 0;
    
    const newStaff: Staff = {
      ...staffData,
      id: `staff-${nextId++}`,
      empCode: `STF-${String(lastEmpCode + 1).padStart(4, "0")}`,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    };
    
    staffDatabase.push(newStaff);
    return newStaff;
  },

  async update(id: string, updates: Partial<Staff>): Promise<Staff> {
    await new Promise(resolve => setTimeout(resolve, 200));
    
    const index = staffDatabase.findIndex(staff => staff.id === id);
    if (index === -1) {
      throw new Error('Staff not found');
    }
    
    const updatedStaff = {
      ...staffDatabase[index],
      ...updates,
      updatedAt: new Date().toISOString(),
    };
    
    staffDatabase[index] = updatedStaff;
    return updatedStaff;
  },

  async delete(id: string): Promise<void> {
    await new Promise(resolve => setTimeout(resolve, 200));
    
    const index = staffDatabase.findIndex(staff => staff.id === id);
    if (index === -1) {
      throw new Error('Staff not found');
    }
    
    staffDatabase[index] = {
      ...staffDatabase[index],
      status: 'terminated',
      updatedAt: new Date().toISOString(),
    };
  },

  async getDepartments(): Promise<string[]> {
    await new Promise(resolve => setTimeout(resolve, 50));
    const departments = [...new Set(staffDatabase
      .map(staff => staff.department)
      .filter(Boolean))] as string[];
    return departments.sort();
  },

  async updateCardIssued(id: string): Promise<Staff> {
    await new Promise(resolve => setTimeout(resolve, 100));
    
    const index = staffDatabase.findIndex(staff => staff.id === id);
    if (index === -1) {
      throw new Error('Staff not found');
    }
    
    const updatedStaff = {
      ...staffDatabase[index],
      cardIssuedAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    };
    
    staffDatabase[index] = updatedStaff;
    return updatedStaff;
  }
};

export { staffService as staffApi };
